















































































import { Component, Vue} from 'vue-property-decorator';
import * as _ from 'underscore';
import moment from 'moment-timezone'

import Spinner from '@/components/utils/Spinner.vue'
import SearchParkingSpotsTable from "./components/SearchParkingSpotsTable.vue";
import SearchParkingSpotsMap from "./components/SearchParkingSpotsMap.vue";
import BookingDateRangePicker from "./components/BookingDateRangePicker.vue"



import { namespace } from "vuex-class";
import "@/store/modules/common";
import { dateRangeInfoType, parkingSpotInfoType } from '@/types/Common';

import { vehicleTypeOptions } from '../utils/enums';
import { userInfoType } from '@/types/Admin';


const commonState = namespace("Common");

@Component({
    components:{
        SearchParkingSpotsTable,
        SearchParkingSpotsMap,
        Spinner,
        BookingDateRangePicker

    }
})
export default class AddBookingsPage extends Vue {
    
    @commonState.State
    public user!: userInfoType;

    @commonState.Action
    public UpdateCurrentDate!: (string) => void;
    
    dataReady = false; 
    searching = false;
    dataLoaded = false; 
    listView = false;   
    
    vehicleType = '';
    vehicleTypeState = true; 
    
 
    updateTables =0

    parkingSpots: parkingSpotInfoType[] = [];

    bookingDate = {} as dateRangeInfoType;
    update = 0;
    dateState = true;
    
    vehicleTypeOptions; 

   

    created() {
        this.vehicleTypeOptions = vehicleTypeOptions;
    }

    mounted() {  
        this.dataLoaded = false;
        this.dataReady = false; 
        this.listView = true;
        this.vehicleTypeState = true;
        this.vehicleType = this.user.vehicle_type;
        this.dataReady = true;
        this.UpdateCurrentDate(moment().format("ddd MMM DD, YYYY HH:mm"))
    }

    public find(){
        this.UpdateCurrentDate(moment().format("ddd MMM DD, YYYY HH:mm"))
        this.dataLoaded = false;
        this.vehicleTypeState = this.vehicleType?true:false;

        this.dateState = (this.bookingDate.startDate && this.bookingDate.endDate)?true:false;

        if (this.vehicleTypeState && this.dateState){ 
            this.searching = true;
            this.parkingSpots = [];

            const body = {                
                "start_date":this.bookingDate.startDate,
                "end_date":this.bookingDate.endDate               
            }

            this.$http.post('/spot', body)
            .then((response) => {            
                if(response?.data){
                    this.parkingSpots =response.data;                    
                }
                this.searching = false;
                this.dataLoaded = true;
                
            },(err) => {
                this.searching = false; 
                this.dataLoaded = true;         
            });
            
        }
    }

    public addBookingDate(bookingDate){
        this.bookingDate = bookingDate
        this.update++;        
        this.find()
    }


}
